/**
 * uni-app 子包路径 → React 工作台路由 转换工具
 *
 * 后端 API（/staffapi/config、getMyConfig 等）返回的菜单 URL 仍是 uni-app 格式
 * （如 /subExpertPackage/pageEditPlace/index），需要映射为 React 路由路径。
 */

/** uni-app 子包路径 → React 工作台路由 映射表 */
export const PATH_MAP: Record<string, string> = {
  // ─── 工作台首页导航 ───
  "/subExpertPackage/pageEditPlace/index": "/workspace/edit-place",
  "/subExpertPackage/pageEditTime/index": "/workspace/edit-time",
  "/subExpertPackage/home/index": "/workspace/home",

  // ─── 订单相关 ───
  "/subExpertPackage/order/index": "/workspace/order",
  "/subExpertPackage/order/detail": "/workspace/order/detail",
  "/subExpertPackage/punching/index": "/workspace/punching",
  "/subExpertPackage/report/index": "/workspace/order/report",
  "/subExpertPackage/comment/index": "/workspace/order/comment",

  // ─── 资金相关 ───
  "/subExpertPackage/pageMoneyDetail/capital": "/workspace/money/capital",
  "/subExpertPackage/pageMoneyDetail/divide": "/workspace/money/divide",
  "/subExpertPackage/pageMoneyDetail/reward": "/workspace/money/reward",
  "/subExpertPackage/pageMoneyDetail/withdraw": "/workspace/money/withdraw",
  "/subExpertPackage/pageMoneyDetail/index": "/workspace/money/capital",

  // ─── 个人中心 ───
  "/subExpertPackage/pageStaffInfo/index": "/workspace/profile",
  "/subExpertPackage/final/index": "/workspace/profile",
  "/subExpertPackage/pageStaffMessage/index": "/workspace/profile/edit",

  // ─── 项目管理 ───
  "/subExpertPackage/pageEditItem/index": "/workspace/edit-item",
  "/subExpertPackage/pageEditItem/my-cate": "/workspace/my-cate",

  // ─── 其他服务 ───
  "/subExpertPackage/pageRequestion/index": "/workspace/requestion",
  "/subExpertPackage/pagesAlbum/index": "/workspace/album",
  "/subExpertPackage/pageEmergency/index": "/workspace/emergency",
  "/subExpertPackage/pagePersonnel/index": "/workspace/personnel",
};

/**
 * 将后端返回的 uni-app 格式 URL 转换为 React 路由路径
 *
 * 转换策略：
 * 1. 先查 PATH_MAP 精确匹配
 * 2. 再做全局前缀替换 /subExpertPackage → /workspace 作为兜底
 * 3. 都匹配不到则原样返回
 */
export function resolveUrl(rawUrl: string): string {
  if (!rawUrl) return rawUrl;
  const exact = PATH_MAP[rawUrl];
  if (exact) return exact;
  const replaced = rawUrl.replace("/subExpertPackage", "/workspace");
  return PATH_MAP[replaced] ?? replaced;
}
